<payee-popup
  [heading]="
    (isCourtProcedure
      ? 'CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.TITLE'
      : isTerminatedSoleEntrepreneur
        ? 'CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.TERMINATED_SOLE_ENTREPRENEUR_TITLE'
        : 'CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.CEASED_TITLE'
    ) | translate
  "
>
  <div class="dialog-content">
    @if (isCourtProcedure) {
      <p class="dialog-message">
        {{
          "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.MESSAGE"
            | translate: { procedureType: procedureTypeLabel, authority: authorityLabel }
        }}
      </p>

      <div class="law-firm-contact">
        <p class="law-firm-name">
          {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.LAW_FIRM_NAME" | translate }}
        </p>
        <p class="law-firm-address">
          {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.LAW_FIRM_ADDRESS" | translate }}
        </p>
        <p>
          <a [href]="'tel:' + lawFirmPhone">{{ lawFirmPhone }}</a>
        </p>
        <p>
          <a [href]="'mailto:' + lawFirmEmail">{{ lawFirmEmail }}</a>
        </p>
      </div>
    } @else if (isTerminatedSoleEntrepreneur) {
      <p class="dialog-message">
        {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.TERMINATED_SOLE_ENTREPRENEUR_MESSAGE" | translate }}
      </p>
    } @else if (isInactiveCompany) {
      <p class="dialog-message">
        {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.CEASED_MESSAGE_LINE_1" | translate }}
      </p>
      <p class="dialog-message">
        {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.CEASED_MESSAGE_LINE_2" | translate }}
      </p>
    }
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="blue-payee"
      width="max"
      height="tall"
      (click)="confirm()"
    >
      {{ "CASE_FORM.FORMS.DEBTOR.COURT_PROCEDURE_DIALOG.OK" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
